/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum InvoiceDataSource {
  Unknown = 0,
  Proteria = 1,
  Ecom = 2,
  ExternalApi = 3,
  ExternalApiEmma = 4,
}
